import { FormControl, RadioGroup } from '@mui/material';
import { useAppSelector } from 'core/store/hooks';
import { PublishedSinceDates } from 'pages/PlaygroundV2Page/helpers';
import RadioButton from '../RadioButton';

const PublishedSinceFilter = ({ localFilters, setLocalFilters }) => {
  const selectedPublishedSince = useAppSelector(
    (state) => state.sourceFilterV2.selectedPublishedSince
  );
  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="published-since-date-radio-buttons-group-label"
        value={localFilters.publishedSince ?? selectedPublishedSince}
        name="published-since-date-buttons-group"
        onChange={(event) =>
          setLocalFilters((prev) => ({
            ...prev,
            publishedSince: event.target.value as PublishedSinceDates,
          }))
        }
      >
        <RadioButton value={PublishedSinceDates.ANY} label="Any" />
        <RadioButton value={PublishedSinceDates.THREE_MONTHS} label="3 months" />
        <RadioButton value={PublishedSinceDates.SIX_MONTHS} label="6 months" />
        <RadioButton value={PublishedSinceDates.ONE_YEAR} label="1 year" />
        <RadioButton value={PublishedSinceDates.TWO_YEARS} label="2 years" />
      </RadioGroup>
    </FormControl>
  );
};

export default PublishedSinceFilter;
